import { AddBoostQueryParams } from '../../../components/pages/connected/Dashboard/DashboardResults/DashboardResultsTable/DashboardResultsTable.types';
import { GetAllBoostHistoryQueryParams } from '../../../types/api/endpoints/boost/history.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const BOOSTS_ENDPOINTS = Object.freeze({
  getAll: () => api.get(StaticGetEndpoints.AllBoosts),

  getAllHistory: (params: GetAllBoostHistoryQueryParams) => api.get(StaticGetEndpoints.AllBoostsHistory, params),

  addHistory: (data: AddBoostQueryParams) => api.post(StaticPostEndpoints.AddBoostsHistory, data),
  removeHistory: (boostHistoryId: number) =>
    api.delete(StaticPostEndpoints.RemoveBoostsHistory, { boostHistoryId }),
});
